<template>
  <div class="checkbox-list">
    <h3 class="u-reset checkbox-list__title">
      {{ title }}
    </h3>

    <ui-model-provider v-slot="{ hasItem, updateValue }" :value.sync="model">
      <ul class="u-reset checkbox-list__items">
        <li v-for="({ id, label }, idx) in items" :key="id" class="checkbox-list__item">
          <ui-checkbox
            :id="getUid(idx)"
            :checked="hasItem(id)"
            :value="id"
            :name="getUid(idx)"
            @change="updateValue($event)"
          >
            <template #label>
              <span class="checkbox-list__label">
                {{ $t(label) }}
              </span>
            </template>
            <template #icon="{ iconClasses }">
              <ui-icon :class="iconClasses" name="checkbox-tick" />
            </template>
          </ui-checkbox>
        </li>
      </ul>
    </ui-model-provider>
  </div>
</template>

<script>
  import UiCheckbox from '@/components/form/ui-checkbox/ui-checkbox'
  import UiModelProvider from '@/components/form/ui-model-provider/ui-model-provider'
  import UiIcon from '@/components/ui-icon/ui-icon'
  import ariaMixin from '@/assets/js/mixin/aria'

  export default {
    components: { UiIcon, UiModelProvider, UiCheckbox },
    mixins: [ariaMixin('projection-selector')],
    props: {
      value: {
        type: Array,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      title: {
        type: String,
        default: null,
      },
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(model) {
          this.$emit('update:value', model)
        },
      },
    },
    methods: {
      getUid(id) {
        return this.ariaUid(null, id)
      },
    },
  }
</script>

<style lang="scss" src="./_checkbox-list.scss" />
